// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__26jUc","calendarButtons":"ClockData_calendarButtons__34xyS"};